import { useState, useEffect } from "react";
import services from "commons/apis/index";

const useGetOpenSales = ({ isActive } = {}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { items } = await services.getOpenSales({ isActive });
        setData(items);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [isActive]);

  return {
    data: data ?? [],
    loading,
  };
};
export default useGetOpenSales;
